<template>
  <div>
    <section class="user_registration text_center base_text_style">
      <h2 class="header_underline">会員登録</h2>

      <ValidationObserver ref="form">
        <form
          action=""
          method="post"
          class="form"
        >
          <div class="form_group">
            <ValidationProvider name="ニックネーム" rules="required|max:50" v-slot="{ errors }">
              <label>ニックネーム</label>
              <input
                type="text"
                name="nickname"
                placeholder="ニックネームを入力してください"
                v-model="form.nickname"
              />
              <span class="valid_error" v-if="errors.length > 0">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="form_group">
            <ValidationProvider name="性別" rules="" v-slot="{ errors }">
              <label>性別</label>
              <div class="select">
                <select
                  name="gender"
                  :class="{
                    select_placeholder: true,
                    selected: form.gender !== 'u'
                  }"
                  v-model="form.gender"
                >
                  <option
                    v-for="(entry, index) in genders"
                    :key="index"
                    :value="entry.value"
                  >
                    {{ entry.label }}
                  </option>
                </select>
              </div>
              <span class="valid_error" v-if="errors.length > 0">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="form_group">
            <ValidationProvider vid="birthYear" name="生年月日(年)" rules="birthNumber" v-slot="{ errors }">
              <label>生年月日(年)</label>
              <div class="select">
                <select
                  name="birth_year"
                  :class="{
                    select_placeholder: true,
                    selected: form.birthYear !== 0
                  }"
                  v-model="form.birthYear"
                >
                  <option value="0">生まれた年を選択してください</option>
                  <option
                    v-for="(entry, index) in years"
                    :key="index"
                    :value="entry"
                  >
                  {{ entry }}年
                  </option>
                </select>
              </div>
              <span class="valid_error" v-if="errors.length > 0">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="form_group">
            <ValidationProvider vid="birthMonth" name="生年月日(月)" rules="birthNumber" v-slot="{ errors }">
              <label>生年月日(月)</label>
              <div class="select">
                <select
                  name="birth_month"
                  :class="{
                    select_placeholder: true,
                    selected: form.birthMonth !== 0
                  }"
                  v-model="form.birthMonth"
                >
                  <option value="0">生まれた月を選択してください</option>
                  <option
                    v-for="(entry, index) in months"
                    :key="index"
                    :value="entry"
                  >
                  {{ entry }}月
                  </option>
                </select>
              </div>
              <span class="valid_error" v-if="errors.length > 0">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="form_group">
            <ValidationProvider
              vid="birthDay"
              name="生年月日(日)"
              :rules="{
                birthNumber: true,
                birthDate: {
                  year: '@birthYear',
                  month: '@birthMonth'
                }
              }"
              v-slot="{ errors }"
            >
              <label>生年月日(日)</label>
              <div class="select">
                <select
                  name="birth_day"
                  :class="{
                    select_placeholder: true,
                    selected: form.birthDay !== 0
                  }"
                  v-model="form.birthDay"
                >
                  <option value="0">生まれた日を選択してください</option>
                  <option
                    v-for="(entry, index) in days"
                    :key="index"
                    :value="entry"
                  >
                  {{ entry }}日
                  </option>
                </select>
              </div>
              <span class="valid_error" v-if="errors.length > 0">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="form_group">
            <ValidationProvider name="血液型" rules="" v-slot="{ errors }">
              <label>血液型</label>
              <div class="select">
                <select
                  name="blood_type"
                  :class="{
                    select_placeholder: true,
                    selected: form.bloodType !== ''
                  }"
                  v-model="form.bloodType"
                >
                  <option
                    v-for="(entry, index) in bloodType"
                    :key="index"
                    :value="entry.value"
                  >
                    {{ entry.label }}
                  </option>
                </select>
              </div>
              <span class="valid_error" v-if="errors.length > 0">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div>
            <p v-if="form.errors.length > 0" class="form_error">
              <span v-for="(error, index) in form.errors" :key="index" class="valid_error">{{ error }}</span>
            </p>
            <p>
              <button
                type="submit"
                class="btn"
                :disabled="isSend"
                @click.prevent="checkForm"
              >登録する</button>
            </p>
            <p>番組からのメール配信、<router-link :to="{ name: 'PageFixed', params: { code: 'terms_of_service' } }" class="link_main--text">利用規約</router-link>に必ず同意の上、ご登録を下さい</p>
            <p>
              <router-link to="/" class="decoration_link_arrow_blue">トップページへ戻る</router-link>
            </p>
          </div>
        </form>
      </ValidationObserver>
    </section>
  </div>
</template>

<script>
import {
  GENDERS_SELECT,
  BIRTH_YEAR_SUB_START,
  BIRTH_YEAR_SUB_END,
  BLOOD_TYPE_SELECT
} from '@/helper/constant'
import { USER_REGISTRATION } from '@/store/user/actions'
import { ERROR_USER_REGISTRATION_BAD_REQUEST } from '@/common/messages'

import {
  ValidationObserver,
  ValidationProvider,
  extend
} from 'vee-validate'
import {
  required,
  max
} from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: '{_field_}を入力してください'
})

extend('max', {
  ...max,
  message: '{_field_}は{length}文字以内で入力してください'
})

extend('birthNumber', {
  validate (value) {
    return Number(value) > 0
  },
  message: '{_field_}を選択してください'
})

extend('birthDate', {
  params: ['year', 'month'],
  validate (day, { year, month }) {
    if (year === 0 || month === 0) {
      return true
    }
    const date = new Date(year, (month - 1), day)
    return (
      date.getFullYear() === year &&
      (date.getMonth() + 1) === month &&
      date.getDate() === day
    )
  },
  message: '日付が正しくありません'
})

export default {
  name: 'UserRegistration',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      genders: GENDERS_SELECT,
      bloodType: BLOOD_TYPE_SELECT,
      form: {
        errors: [],
        nickname: null,
        gender: 'u',
        birthYear: 0,
        birthMonth: 0,
        birthDay: 0,
        bloodType: ''
      },
      isSend: false
    }
  },
  computed: {
    years: function () {
      const dt = new Date()
      const nowYear = dt.getFullYear()
      const startYear = nowYear - BIRTH_YEAR_SUB_START
      const endYear = nowYear - BIRTH_YEAR_SUB_END

      const len = endYear - startYear
      const sequential = new Array(len)
      for (let i = 0, len = sequential.length; i <= len; i++) {
        sequential[i] = endYear - i
      }

      return sequential
    },
    months: function () {
      const len = 12
      const sequential = new Array(len)
        .fill(1)
        .map((n, i) => n + i)

      return sequential
    },
    days: function () {
      const len = 31
      const sequential = new Array(len)
        .fill(1)
        .map((n, i) => n + i)

      return sequential
    }
  },
  methods: {
    checkForm () {
      if (this.isSend) return
      this.isSend = true

      this.$refs.form.validate().then(success => {
        if (success) {
          this.createUser()
        } else {
          this.isSend = false
        }
      })
    },
    createUser () {
      const form = this.form
      const birthYear = form.birthYear
      const birthMonth = ('00' + form.birthMonth).slice(-2)
      const birthDay = ('00' + form.birthDay).slice(-2)
      const date = String(birthYear) + '-' + String(birthMonth) + '-' + String(birthDay)
      const params = {
        nickname: form.nickname,
        gender: form.gender,
        birthday: date,
        blood_type: form.bloodType,
        params: JSON.stringify(this.$route.query)
      }
      this.$store.dispatch(USER_REGISTRATION, params)
        .then((data) => {
          this.$router.pushIsses({ name: 'UserRegistrationComplete' }, false)
        })
        .catch((error) => {
          this.isSend = false
          this.form.errors = []

          let message = ERROR_USER_REGISTRATION_BAD_REQUEST
          if (error.errorStatus === 400) {
            message = message + '\n' + error.message
          } else if (error.errorStatus === 422) {
            Object.keys(error.errorData).forEach((key) => {
              error.errorData[key].forEach(entry => {
                this.form.errors.push(entry)
              })
            })
          } else {
            message = error.message
          }

          this.form.errors.push(message)
        })
    }
  }
}
</script>
